import { createContext, ReactNode } from 'react';
import { NewCasinoGame } from 'interfaces/new-casino';

type Props = {
  children: ReactNode;
  value: {
    games: NewCasinoGame[] | null;
    onCheck: (value: NewCasinoGame) => void | null;
  };
};
export const PersonalizedGamesContext = createContext<Props['value']>({
  games: null,
  onCheck: () => {}
});

export const PersonalizedGamesProvider = ({ children, value }: Props) => {
  return (
    <PersonalizedGamesContext.Provider value={value}>
      {children}
    </PersonalizedGamesContext.Provider>
  );
};
